function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 16,
  fill: "white"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("rect", {
  x: -4.5,
  y: -12.5,
  width: 49,
  height: 64,
  rx: 3.5,
  fill: "#E5E5EF",
  stroke: "#E5E5EF",
  strokeDasharray: "2 2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.9202 4C24.3097 4 27.8531 7.86547 27.8531 12.654C27.8531 17.4426 24.3097 21.3081 19.9202 21.3081C15.5307 21.3081 11.9873 17.4426 11.9873 12.654C11.9873 7.86547 15.5307 4 19.9202 4Z",
  fill: "#4A4A4A"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.9202 42.9432C13.009 42.9432 6.8995 39.4266 3.33331 34.0968C3.41625 28.6297 14.3913 25.6351 19.9202 25.6351C25.4216 25.6351 36.4242 28.6297 36.5072 34.0968C32.941 39.4266 26.8315 42.9432 19.9202 42.9432Z",
  fill: "#4A4A4A"
}));

function SvgUserProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user-profile.b01a3df6.svg";
export { ForwardRef as ReactComponent };